import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import InputComponent from "../../components/InputComponent";
import Toast from "../../helpers/Toast";
import { useIntl } from "react-intl";
import { CheckListModelTaskService } from "../../services/CheckListModelTaskService";
import { CreateCheckListModelTaskDTO, CreateCheckListModelTaskDTOSchema } from "../../models/CheckListModelTask/CreateCheckListModelTaskDTO";


// Definição dos tipos das props
interface CheckListModelTaskCreateModalProps {
    isOpen: boolean;
    toggle: () => void;
    checkListModelId: number;
    onTaskCreated: () => void;
}

const CheckListModelTaskCreateModal: React.FC<CheckListModelTaskCreateModalProps> = ({
    isOpen,
    toggle,
    checkListModelId,
    onTaskCreated,
}) => {
    const intl = useIntl();
    const service = new CheckListModelTaskService();

    const [createDTO, setCreateDTO] = useState<CreateCheckListModelTaskDTO>({
        title: "",
        description: "",
        order: 0,
        checkListModelId: checkListModelId,
    });

    const [loadingCreate, setLoadingCreate] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setCreateDTO({
                title: "",
                description: "",
                order: 0,
                checkListModelId: checkListModelId, 
            });
        }
    }, [isOpen]); 

    const createTask = async () => {
        setLoadingCreate(true);

        const { error } = CreateCheckListModelTaskDTOSchema.validate(createDTO, { abortEarly: false });
        if (error) {
            Toast.Show("error", error.details.map(detail => detail.message).join(', '));
            setLoadingCreate(false);
            return;
        }

        const response = await service.Create({
            ...createDTO,
            checkListModelId,
        });

        if (!response.success) {
            Toast.Show("error", response.message);
            setLoadingCreate(false);
            return;
        }

        Toast.Show("success", response.message || intl.formatMessage({ id: "Screens.CheckListModelTask.Create.SuccessMessage" }));

        setCreateDTO({
            title: "",
            description: "",
            order: 1,
            checkListModelId: checkListModelId,
        });


        setLoadingCreate(false);
        onTaskCreated();
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>{intl.formatMessage({ id: "Screens.CheckListModelTask.Create.Title" })}</ModalHeader>
            <ModalBody>
                <InputComponent
                    xl={12} lg={12} md={12} sm={12} xs={12}
                    type="text"
                    label={intl.formatMessage({ id: "Screens.CheckListModelTask.Create.Info.Title" })}
                    value={createDTO.title}
                    onChange={(t: string) => setCreateDTO({ ...createDTO, title: t })}
                />
                <InputComponent
                    xl={12} lg={12} md={12} sm={12} xs={12}
                    label={intl.formatMessage({ id: "Screens.CheckListModelTask.Create.Info.Description" })}
                    type="textArea"
                    value={createDTO.description || ""}
                    readOnly={false}
                    onChange={(value) => setCreateDTO({ ...createDTO, description: value })}
                />
                <InputComponent
                    xl={12} lg={12} md={12} sm={12} xs={12}
                    type="number"
                    label={intl.formatMessage({ id: "Screens.CheckListModelTask.Create.Info.Order" })}
                    value={createDTO.order.toString()}
                    onChange={(t: string) => setCreateDTO({ ...createDTO, order: Number(t) })}
                />
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>{intl.formatMessage({ id: "General.Cancel" })}</Button>
                <Button color="primary" onClick={createTask} disabled={loadingCreate}>
                    {loadingCreate ? intl.formatMessage({ id: "General.Loading" }) : intl.formatMessage({ id: "Screens.CheckListModelTask.Create.Button.Create" })}
                </Button>
            </ModalFooter>
        </Modal>
    );
}
export default CheckListModelTaskCreateModal;
